// Plausible analytics script is loaded directly in index.html <head>.
// This component is kept as a mount point for future custom event tracking.
export function Analytics() {
  return null;
}
